import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import { Flag, Users } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

const BackToHomeButton = () => {
  const navigate = useNavigate();
  return (
    <Button variant="independence" onClick={() => navigate("/")}>
      Kembali ke Beranda
    </Button>
  );
};

const AboutBazar = () => {
  return (
    <div className="min-h-screen bg-gradient-hero flex items-center justify-center p-4">
      <Card className="w-full max-w-2xl bg-gradient-card border-none shadow-independence">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 w-16 h-16 bg-gradient-independence rounded-full flex items-center justify-center">
            <Flag className="w-8 h-8 text-primary-foreground" />
          </div>
          <CardTitle className="text-3xl font-bold">
            Tentang Bazaria Digital
          </CardTitle>
          <CardDescription>
            Merayakan HUT Kemerdekaan RI ke-80 dengan marketplace digital yang
            menampilkan produk-produk lokal terbaik Indonesia.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <section>
            <h2 className="text-xl font-semibold mb-2">Misi & Visi</h2>
            <p className="text-muted-foreground">
              Misi kami adalah agar karyawan BAP bisa menjual produk mereka
              secara online di platform Bazaria Digital, visi kami adalah
              membangun ekonomi kerakyatan melalui digitalisasi bazaar
              kemerdekaan, mendukung UMKM, dan memperkenalkan produk lokal ke
              masyarakat luas.
            </p>
          </section>
          <section>
            <h2 className="text-xl font-semibold mb-2">Tim Penyelenggara</h2>
            <div className="flex items-center space-x-2 text-muted-foreground">
              <Users className="w-5 h-5 text-primary" />
              <span>BAP Digital UMKM Surabaya</span>
            </div>
          </section>
          <section>
            <h2 className="text-xl font-semibold mb-2">Tujuan Bazaar</h2>
            <ul className="list-disc pl-6 text-muted-foreground">
              <li>Mendukung pertumbuhan UMKM lokal.</li>
              <li>Memperluas akses pasar produk.</li>
              <li>Mempererat semangat kemerdekaan dan kolaborasi</li>
            </ul>
          </section>
          <div className="pt-6 text-center">
            <BackToHomeButton />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AboutBazar;
